import { getAnnotationsOfUser, getSlidesToAnnotate } from "@/api/craiyon";
import { Annotation, normalize, Slide } from "@/store/helper";
import Vue from "vue";
import { getAnnotationsForSlide } from "../../api/craiyon";

const MODULE = "annotation/";
const _SET_CURRENT_SLIDE = "SET_CURRENT_SLIDE";
const _SET_SLIDES = "SET_SLIDES";
const _ANNOTATE_NEXT = "ANNOTATE_NEXT";
const _ANNOTATE_PREVIOUS = "ANNOTATE_PREVIOUS";
const _CURRENT_SLIDE = "_CURRENT_SLIDE";
const _LOAD_SLIDES_TO_ANNOTATE = "_LOAD_SLIDES_TO_ANNOTATE";
const _LOADING = "LOADING";
const _TOGGLE_LOADING = "_TOGGLE_LOADING";
const _RESET_SLIDES = "_RESET_SLIDES";
const _FIND = "FIND";
const _LIST = "LIST";
const _TOTAL = "TOTAL";
const _SET_CURRENT_INDEX = "_SET_CURRENT_INDEX";
const _LOAD_ANNOTATIONS = "_LOAD_ANNOTATIONS";
const _LOAD_SLIDES_WITH_DIAGNOSIS = "_LOAD_SLIDES_WITH_DIAGNOSIS";

export const LOAD_ANNOTATIONS = MODULE + _LOAD_ANNOTATIONS;
export const SET_CURRENT_INDEX = MODULE + _SET_CURRENT_INDEX;
export const LIST = MODULE + _LIST;
export const FIND = MODULE + _FIND;
export const TOTAL = MODULE + _TOTAL;
export const LOADING = MODULE + _LOADING;
export const LOAD_SLIDES_TO_ANNOTATE = MODULE + _LOAD_SLIDES_TO_ANNOTATE;
export const CURRENT_SLIDE = MODULE + _CURRENT_SLIDE;
export const SET_CURRENT_SLIDE = MODULE + _SET_CURRENT_SLIDE;
export const SET_SLIDES = MODULE + _SET_SLIDES;
export const ANNOTATE_NEXT = MODULE + _ANNOTATE_NEXT;
export const ANNOTATE_PREVIOUS = MODULE + _ANNOTATE_PREVIOUS;
export const LOAD_SLIDES_WITH_DIAGNOSIS = MODULE + _LOAD_SLIDES_WITH_DIAGNOSIS;

const state = {
  slides: null,
  currentSlide: null,
  currentIndex: -1,
  loading: false,
  byId: {},
  allIds: undefined
};

const getters = {
  [_CURRENT_SLIDE](state) {
    const id = state.allIds[state.currentIndex];
    return state.byId[id];
  },
  [_TOTAL](state) {
    return state.rawSlides.count;
  },
  [_FIND](state) {
    return id => state.byId[id];
  },
  [_LIST](state, getters) {
    if (state.allIds === undefined) return undefined;
    return state.allIds.map(id => getters[_FIND](id)).filter(e => e);
  }
};

const mutations = {
  add: (state, item) => {
    if (state.allIds === undefined) state.allIds = [];
    for (let key of Object.keys(item)) {
      Vue.set(state.byId, key, item[key]);
      if (state.allIds.includes(key)) return;
      state.allIds.push(key);
    }
  },
  incrementCurrentSlideIndex: state => state.currentIndex++,
  decreaseCurrentSlideIndex: state => state.currentIndex--,
  [_SET_SLIDES](state, { slides }) {
    state.slides = slides;
  },
  // [_SET_CURRENT_SLIDE](state, { slide }) {
  //   console.log(state.allIds);
  //
  //   // const index = state.allIds.indexOf(slide.id.toString());
  //   state.currentIndex = index;
  // },
  [_TOGGLE_LOADING](state) {
    state.loading = !state.loading;
  },
  [_RESET_SLIDES](state) {
    state.slides = [];
    state.byId = {};
    state.allIds = [];
  },
  [_SET_CURRENT_INDEX](state, index) {
    state.currentIndex = index;
  }
};

const actions = {
  async [_LOAD_SLIDES_TO_ANNOTATE]({ commit, state, rootGetters, rootState }) {
    // only load if not loaded yet
    if (state.allIds) return;

    commit(_RESET_SLIDES);
    commit(_TOGGLE_LOADING);
    const token = rootGetters.token;
    const slides = await getSlidesToAnnotate(token);
    slides.forEach(s => {
      const flat = normalize(s, Slide);
      commit("add", flat.entities.slide);
      console.log(flat);
      commit("project/add", flat.entities.project, { root: true });
      commit("user/add", flat.entities.user, { root: true });
      commit("annotationClass/add", flat.entities.annotationClass, {
        root: true
      });
    });
    commit(_TOGGLE_LOADING);
  },
  async [_LOAD_SLIDES_WITH_DIAGNOSIS]({ commit, state, rootGetters, rootState }) {
    commit(_RESET_SLIDES);
    commit(_TOGGLE_LOADING);
    const token = rootGetters.token;
    const slides = await getSlidesToAnnotate(token);
    for (let index = 0; index < slides.length; index++) {
      const s = slides[index];
      const flat = normalize(s, Slide);
      const annotation = await getAnnotationsForSlide(
        token,
        s.id
      )
      flat.entities.slide[s.id].diagnosis = annotation
      // if (annotation.length > 0)
      //   flat.entities.slide[s.id].diagnosis = annotation
      commit("add", flat.entities.slide);
      console.log(flat);
      commit("project/add", flat.entities.project, { root: true });
      commit("user/add", flat.entities.user, { root: true });
      commit("annotationClass/add", flat.entities.annotationClass, {
        root: true
      });
    }
    commit(_TOGGLE_LOADING);
  },
  async [_LOAD_ANNOTATIONS]({ commit, state, rootGetters, rootState }) {
    commit(_RESET_SLIDES);
    commit(_TOGGLE_LOADING);
    const token = rootGetters.token;
    const annotations = await getAnnotationsOfUser(token);
    annotations.forEach(s => {
      const flat = normalize(s, Annotation);
      commit("add", flat.entities.annotation);
      commit("annotationClass/add", flat.entities.annotationClass, {
        root: true
      });
    });
    commit(_TOGGLE_LOADING);
  },
  [_ANNOTATE_NEXT]({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.currentIndex === state.allIds.length - 1) {
        reject();
        return;
      }
      commit("incrementCurrentSlideIndex");
      resolve();
    });
  },
  [_ANNOTATE_PREVIOUS]({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.currentIndex === 0) {
        reject();
        return;
      }
      commit("decreaseCurrentSlideIndex");
      resolve();
    });
  },
  [_SET_CURRENT_SLIDE]({ commit, state }, { slide }) {
    const flat = normalize(slide, Slide);
    commit("add", flat.entities.slide);

    const index = state.allIds.indexOf(slide.id.toString());
    commit(_SET_CURRENT_INDEX, index);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
